import React from "react";
import styles from "./PaymentDetails.module.sass";
import Table from "../../components/ui/Table/Table";
import PaymentMethods from "../../components/PaymentMethods/PaymentMethods";
import AccountList from "../../components/AccountList/accountList";
import { Collapse } from "react-bootstrap";
import currency from "../../utils/currency";
import { inputType } from "../ui/Input/Input";
import Input from "../ui/Input/Input";
import validation from "../../utils/validation";
import masks from "../../utils/masks";
import theme from "../../App.module.sass";
import Reminder from "../Reminder/Reminder";
import AppContext from "../../contexts/appContext";
import env from "../../config/environment";

const getSelectedStyle = condition => condition ? styles.selected: ''
const getArrowStyle = open => open ? "icon icon-seta-baixo-p" : "icon icon-seta-cima-p"
class PaymentDetails extends React.Component {
  targetDiv = React.createRef();
  static contextType = AppContext;
  state = {
    open: false,
    tableHeaders: [],
    tableRows: [],
    method: "",
    debitInfo: {
      accountIndex: -1,
      anotherAccount: !this.props.ibc,
      operation: "",
      agency: "",
      account: "",
      digit: "",
    },
    creditInfo: {
      cardNumber: "",
      validity: "",
      ccv: "",
      titular: "",
      titularCPF: "",
    },
  };

  PFDebitOptions = [
    { value: "001", text: "Conta corrente de PF" },
    { value: "013", text: "Poupança de PF" },
  ];

  PJDebitOptions = [
    { value: "003", text: "Conta corrente de PJ" },
    { value: "022", text: "Poupança de PJ" },
  ];

  getDebitOptions = () => {
    return this.props.selectedIdentifier === "cpf"
      ? this.PFDebitOptions
      : this.PJDebitOptions;
  };

  getInfo = () => {
    return {
      method: this.state.method,
      debitInfo: { ...this.state.debitInfo },
      creditInfo: { ...this.state.creditInfo },
    };
  };

  onSelectedValue = (value) => {
    if (value === this.state.method) {
      return;
    }
    this.setState({
      method: value,
      debitInfo: {
        accountIndex: this.props.ibc ? -1 : 0,
        anotherAccount: !this.props.ibc,
        operation: "",
        agency: "",
        account: "",
        digit: "",
      },
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.hasOwnProperty("onChange") && prevState !== this.state) {
      this.props.onChange(this.getInfo());
    }

    if (
      prevProps.parcelas !== this.props.parcelas ||
      this.props.parcelas.length !== this.state.tableRows.length
    ) {
      const tableHeaders = [
        {
          text: "Parcelas",
        },
        {
          text: "Total",
          className: styles.totalInfo,
          bold: true,
        },
      ];

      const tableRows = this.props.parcelas.map((el) => ({
        interval:
          el.inicio === el.fim
            ? el.inicio + "ª parcela"
            : "da " + el.inicio + "ª até a " + el.fim + "ª",
        total: "R$ " + currency.numberToCurrency(el.valor),
      }));

      this.setState({
        tableHeaders: tableHeaders,
        tableRows: tableRows,
      });
    }
  }

  render() {
    const contextType = this.context;
    const textBolAuto = (
      <>
        O pagamento do seu boleto deve ser feito em{" "}
        <strong>até 3 dias úteis.</strong> Este prazo é apenas para o pagamento
        da primeira parcela do seu consórcio. Para as demais parcelas, o
        vencimento <strong>será sempre no dia 15.</strong>
      </>
    );
    const textDebitAuto = (
      <>
        O débito vai ocorrer na sua conta em{" "}
        <strong>1 dia (útil), a contar da data de venda.</strong> Este prazo é
        apenas para o pagamento da primeira parcela do seu consórcio. Para as
        demais parcelas, o vencimento <strong>será sempre no dia 15.</strong>
      </>
    );
    const textBolResidence = (
      <>
        O pagamento do seu boleto deve ser feito em{" "}
        <strong>até 3 dias úteis.</strong> Este prazo é apenas para o pagamento
        da primeira parcela do seu consórcio. Para as demais parcelas, o
        vencimento <strong>será sempre no dia 10.</strong>
      </>
    );
    const textDebitResidence = (
      <>
        O débito vai ocorrer na sua conta em{" "}
        <strong>1 dia (útil), a contar da data de venda.</strong> Este prazo é
        apenas para o pagamento da primeira parcela do seu consórcio. Para as
        demais parcelas, o vencimento <strong>será sempre no dia 10.</strong>
      </>
    );
    const textCreditCard = (
      <>
        Pagamento em{" "}
        <strong>cartão de crédito só está disponível para a 1ª parcela.</strong>{" "}
        As demais você deverá escolher entre boleto ou débito em conta Caixa.
      </>
    );

    return (
      <div className={styles.PaymentDetails}>
        <PaymentMethods
          value={this.state.method}
          allowCC={env.ENABLE_CC === "true" && !this.props.secondary}
          selectedMethod={this.onSelectedValue}
        />

        {this.props.ibc && this.state.method === "DB" && (
          <>
            <React.Fragment>
              {contextType.product && contextType.product.id === "1" ? (
                <Reminder text={textDebitResidence} />
              ) : (
                <Reminder text={textDebitAuto} />
              )}
            </React.Fragment>
            <React.Fragment>
              <p className={`${styles.subtitle} ${styles.accountSubtitle}`}>
                Escolha sua conta ou informe uma nova
              </p>
              <AccountList
                selectedIndex={this.state.debitInfo.accountIndex}
                onChange={(data) => {
                  this.setState({
                    debitInfo: {
                      accountIndex: data.accountIndex,
                      anotherAccount: data.anotherAccount,
                      operation: data.operation,
                      agency: data.agency,
                      account: data.account,
                      digit: data.digit,
                    },
                  });
                }}
              />
            </React.Fragment>
          </>
        )}

        {this.state.method === "DB" && this.state.debitInfo.anotherAccount && (
          <>
            <React.Fragment>
              {contextType.product && contextType.product.id === "1" ? (
                <Reminder text={textDebitResidence} />
              ) : (
                <Reminder text={textDebitAuto} />
              )}
            </React.Fragment>
            <React.Fragment>
              <p className={`${styles.subtitle} ${styles.debitInfo}`}>
                Insira os dados da conta
              </p>
              <p>Banco: Caixa Economica Federal</p>
              <div className={[theme.row, styles.accountInfo].join(" ")}>
                <Input
                  value={this.state.debitInfo.operation}
                  type={inputType.DROPDOWN}
                  onSelect={(value) =>
                    this.setState({
                      debitInfo: { ...this.state.debitInfo, operation: value },
                    })
                  }
                  options={this.getDebitOptions()}
                  validationRules={[validation.required]}
                  typeDocument={"Operação"}
                  className={theme.col30}
                />

                <Input
                  value={this.state.debitInfo.agency}
                  onChange={(value) =>
                    this.setState({
                      debitInfo: { ...this.state.debitInfo, agency: value },
                    })
                  }
                  mask={masks.numberOnly}
                  validationRules={[
                    validation.required,
                    validation.minLength(4),
                  ]}
                  maxLength={4}
                  typeDocument={"Agência"}
                  className={theme.col20}
                />
                <Input
                  value={this.state.debitInfo.account}
                  onChange={(value) =>
                    this.setState({
                      debitInfo: { ...this.state.debitInfo, account: value },
                    })
                  }
                  mask={masks.numberOnly}
                  validationRules={[validation.required]}
                  maxLength={12}
                  typeDocument={"Conta"}
                  className={theme.col30}
                />
                <p className={styles.divider}>-</p>
                <Input
                  value={this.state.debitInfo.digit}
                  onChange={(value) =>
                    this.setState({
                      debitInfo: { ...this.state.debitInfo, digit: value },
                    })
                  }
                  mask={masks.numberOnly}
                  validationRules={[validation.required]}
                  maxLength={1}
                  typeDocument={"Dígito"}
                  className={theme.col20}
                />
              </div>
            </React.Fragment>
          </>
        )}

        {this.state.method === "BB" && (
          <React.Fragment>
            <React.Fragment>
              {contextType.product && contextType.product.id === "1" ? (
                <Reminder text={textBolResidence} />
              ) : (
                <Reminder text={textBolAuto} />
              )}
            </React.Fragment>
          </React.Fragment>
        )}

        {this.state.method === "CC" && (
          <React.Fragment>
            <Reminder text={textCreditCard} />
            <p className={`${styles.subtitle} ${styles.debitInfo}`}>
              Insira os dados do cartão
            </p>
            <div className={[theme.row, styles.complement].join(" ")}>
              <Input
                value={this.state.creditInfo.cardNumber}
                type="tel"
                onChange={(value) => {
                  this.setState({
                    creditInfo: {
                      ...this.state.creditInfo,
                      cardNumber: masks.creditCard(value).replace(/\D/g, ""),
                    },
                  });
                }}
                validationRules={[validation.required, validation.credicCard]}
                typeDocument={"Nº do cartão de crédito"}
                className={theme.col50}
                maxLength={30}
                mask={masks.creditCard}
              />

              <div className={[theme.col50, styles.row].join(" ")}>
                <Input
                  value={this.state.creditInfo.validity}
                  type="tel"
                  onChange={(value) =>
                    this.setState({
                      creditInfo: {
                        ...this.state.creditInfo,
                        validity: value.substr(0, 4),
                      },
                    })
                  }
                  mask={masks.creditValidity}
                  validationRules={[
                    validation.required,
                    validation.creditValidity,
                  ]}
                  typeDocument={"Validade"}
                  maxLength="5"
                />
                <Input
                  value={this.state.creditInfo.ccv}
                  type="tel"
                  onChange={(value) =>
                    this.setState({
                      creditInfo: { ...this.state.creditInfo, ccv: value },
                    })
                  }
                  validationRules={[
                    validation.required,
                    validation.minLength(3),
                  ]}
                  typeDocument={"CCV"}
                  mask={masks.numberOnly}
                  maxLength={3}
                />
              </div>
            </div>

            <div className={[theme.row, styles.complement].join(" ")}>
              <Input
                value={this.state.creditInfo.titular}
                onChange={(value) =>
                  this.setState({
                    creditInfo: { ...this.state.creditInfo, titular: value },
                  })
                }
                type="text"
                validationRules={[
                  validation.required,
                  validation.minLength(3),
                  validation.lettersOnly,
                ]}
                typeDocument={"Titular"}
                maxLength={79}
                className={theme.col60}
              />
              <Input
                value={this.state.creditInfo.titularCPF}
                onChange={(value) =>
                  this.setState({
                    creditInfo: { ...this.state.creditInfo, titularCPF: value },
                  })
                }
                type="tel"
                validationRules={[validation.required, validation.vCpf]}
                mask={masks.cpf}
                typeDocument={"Documento de identificação"}
                maxLength={14}
                className={theme.col40}
              />
            </div>
          </React.Fragment>
        )}

        {this.state.method !== "" && this.state.method !== "CC" ? (
          <div>
            <div className={styles.details}>
              <label>
                Parcelas a partir de{" "}
                <b>R$ {currency.numberToCurrency(this.props.parcelaMedia)}</b>
              </label>
              <div
                ref={(el) => (this.targetDiv = el)}
                onClick={() => this.setState({ open: !this.state.open })}
                className={[
                  styles.moreDetails,
                  getSelectedStyle(this.state.open),
                ].join(" ")}
              >
                <span role="link">Ver todas as parcelas</span>
                <i
                  className={
                    getArrowStyle(!this.state.open)
                  }
                />
              </div>
            </div>
            <div
              className={[
                styles.expandedArea,
                getSelectedStyle(this.state.open),
              ].join(" ")}
            >
              <Collapse
                in={this.state.open}
                onEntered={() => {
                  /*this.targetDiv.scrollIntoView({behavior: "smooth", block: "start"})*/
                }}
              >
                <div className={styles.parcelas}>
                  {this.state.tableRows.length > 0 ? (
                    <React.Fragment>
                      <Table
                        headers={this.state.tableHeaders}
                        rows={this.state.tableRows}
                      />
                      <p className={styles.bottomInfo}>
                        O valor do crédito e da parcela é corrigido a cada 12
                        assembleias do grupo, de acordo com o Índice Nacional de
                        Preços ao Consumidor – INPC, garantindo assim, o seu
                        poder de compra.
                      </p>
                    </React.Fragment>
                  ) : (
                    <h2>Informações sobre parcelas ainda não disponíveis</h2>
                  )}
                </div>
              </Collapse>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default PaymentDetails;
